
import { defineComponent, computed } from "vue-demi";

import NoTasksImage from "@/modules/Notifications/NotificationsPopover/images/no-tasks.svg";
import NoNewsImage from "@/modules/Notifications/NotificationsPopover/images/no-news.svg";

const EMPTY_CONTENT = {
  tasks: {
    title: "No task updates yet",
    description: "We’ll notify you when there are any upcoming or overdue tasks. Stay tuned!",
    image: NoTasksImage,
  },
  news: {
    title: "No updates yet",
    description: "We’ll let you know as soon as something new is available",
    image: NoNewsImage,
  },
};

export default defineComponent({
  name: "NotificationsEmpty",

  props: {
    type: {
      type: String,
      default: "tasks",
      validator: (value: string) => ["tasks", "news"].includes(value),
    },
  },

  setup(props) {
    const content = computed(() => EMPTY_CONTENT[props.type as keyof typeof EMPTY_CONTENT]);

    return {
      content,
    };
  },
});
